export default "3.0.0";